import { useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import {
  MANAGE_SUBS_EXPORT_MANAGE_ACCOUNT_AUDIT_TRAIL_BEGIN,
  MANAGE_SUBS_EXPORT_MANAGE_ACCOUNT_AUDIT_TRAIL_SUCCESS,
  MANAGE_SUBS_EXPORT_MANAGE_ACCOUNT_AUDIT_TRAIL_FAILURE,
  MANAGE_SUBS_EXPORT_MANAGE_ACCOUNT_AUDIT_TRAIL_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import fileDownload from 'js-file-download';
import { EXPORT_BOS_API_REQUEST_URL } from '../../../common/apiConfig';
export function exportManageAccountAuditTrail(args = {}) {
  return (dispatch,getState) => { // optionally you can have getState as the second argument
    dispatch({
      type: MANAGE_SUBS_EXPORT_MANAGE_ACCOUNT_AUDIT_TRAIL_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      const cognitoIdToken = getState().home.auth.cognitoIdToken;
      const token = `Bearer ${cognitoIdToken}`;
      const doRequest = axios({
        url: `${EXPORT_BOS_API_REQUEST_URL}/accountEvents/accountEventExport`,
        method: 'post',
        data: args,
        responseType: 'blob',
        headers: {
          'Authorization': token,
        }
      });
      doRequest.then(
        (res) => {
          dispatch({
            type: MANAGE_SUBS_EXPORT_MANAGE_ACCOUNT_AUDIT_TRAIL_SUCCESS,
            data: res.data,
          });
          resolve(res.data);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          const errorMsg = err && err.response ? err.response.data.message : 'There is an error. Please refresh page or contact administrator.';
          dispatch({
            type: MANAGE_SUBS_EXPORT_MANAGE_ACCOUNT_AUDIT_TRAIL_FAILURE,
            data: { error: errorMsg },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissExportManageAccountAuditTrailError() {
  return {
    type: MANAGE_SUBS_EXPORT_MANAGE_ACCOUNT_AUDIT_TRAIL_DISMISS_ERROR,
  };
}

export function useExportManageAccountAuditTrail() {
  const dispatch = useDispatch();

  const { exportManageAccountAuditTrailPending, exportManageAccountAuditTrailError } = useSelector(
    state => ({
      exportManageAccountAuditTrailPending: state.manageSubs.exportManageAccountAuditTrailPending,
      exportManageAccountAuditTrailError: state.manageSubs.exportManageAccountAuditTrailError,
    }),
    shallowEqual,
  );

  const boundAction = useCallback((...args) => {
    return dispatch(exportManageAccountAuditTrail(...args));
  }, [dispatch]);

  const boundDismissError = useCallback(() => {
    return dispatch(dismissExportManageAccountAuditTrailError());
  }, [dispatch]);

  return {
    exportManageAccountAuditTrail: boundAction,
    exportManageAccountAuditTrailPending,
    exportManageAccountAuditTrailError,
    dismissExportManageAccountAuditTrailError: boundDismissError,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case MANAGE_SUBS_EXPORT_MANAGE_ACCOUNT_AUDIT_TRAIL_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        exportManageAccountAuditTrailPending: true,
        exportManageAccountAuditTrailError: null,
      };

    case MANAGE_SUBS_EXPORT_MANAGE_ACCOUNT_AUDIT_TRAIL_SUCCESS:
      // The request is success
      fileDownload(action.data, `Manage Accounts Audit Trail Reports.xlsx`);
      return {
        ...state,
        exportManageAccountAuditTrailPending: false,
        exportManageAccountAuditTrailError: null,
      };

    case MANAGE_SUBS_EXPORT_MANAGE_ACCOUNT_AUDIT_TRAIL_FAILURE:
      // The request is failed
      return {
        ...state,
        exportManageAccountAuditTrailPending: false,
        exportManageAccountAuditTrailError: action.data.error,
      };

    case MANAGE_SUBS_EXPORT_MANAGE_ACCOUNT_AUDIT_TRAIL_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        exportManageAccountAuditTrailError: null,
      };

    default:
      return state;
  }
}
